import React from 'react';
import { useTranslation } from 'react-i18next';
import HtmlParser from 'react-html-parser';

import config from 'config';

import classes from './MobileApps.module.scss';

const MobileApps: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      {/* <div className={classes.advice}>
        <div className={classes.adviceTitle}>
          <h2>{t('advice_title')}</h2>
          <p>{t('advice_sub_title')}</p>
        </div>
        <a href="https://b-advice.uz/" target="_blank" className={classes.adviceImage}>
          <img src="/badvice.jpg" alt="badvice" />
        </a>
      </div> */}
      <div className={classes.wrapper}>
        <div className={classes.image} />
        <div className={classes.content}>
          <div className={classes.title}>{HtmlParser(t('Mobile_app_for_licensing'))}</div>
          <div className={classes.description}>{HtmlParser(t('Mobile_app_for_licensing_description'))}</div>
          <div className={classes.store}>
            <a href={config.apps.android} className={classes.storeItem} target="_blank">
              <img src={require('assets/images/store/playstore.svg')} alt="playstore" />
            </a>
            <a href={config.apps.ios} className={classes.storeItem} target="_blank">
              <img src={require('assets/images/store/appstore.svg')} alt="appstore" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileApps;
